import React, { FC } from 'react';
import { ProductsListPageSkeleton } from '../placementProduct/placementProductSkeleton';

export const Preview3DProductsPageSkeleton: FC = () => <ProductsListPageSkeleton titleWidth='250px' actionWidth='' />;
